const translations = {
    faaRegistrationNumberFieldLabel: 'FAA Registration #'
};

export default translations;
